import locationApi from 'api/locationApi';
import { put, takeLeading } from 'redux-saga/effects';

import { apiErrorHandler, showSuccess } from 'utils';

import {
  actionGetRoomStatusList,
  actionGetRoomStatusListFailed,
  actionGetRoomStatusListSuccess,
  actionUpdateLocationFailed,
  actionUpdateLocationSuccess,
  actionQuickUpdateRoomStatusFailed,
  actionQuickUpdateRoomStatusSuccess,
} from './actions';
import { GET_ROOM_STATUS_LIST, QUICK_UPDATE_ROOM_STATUS, UPDATE_ROOM_STATUS_LIST } from './actionTypes';

function* getRoomStatusList({ payload }) {
  try {
    const response = yield locationApi.getRoomStatusList(payload);

    yield put(actionGetRoomStatusListSuccess(response.payload));
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetRoomStatusListFailed());
  }
}

function* updateRoomStatusList({ payload }) {
  const {
    filter, callback, roomInfo, newRoomStatus,
  } = payload;

  try {
    yield locationApi.updateRoomStatus({
      roomInfo,
      newRoomStatus,
    });

    yield put(actionUpdateLocationSuccess());

    showSuccess('Cập nhật thông tin phòng thành công');

    yield put(actionGetRoomStatusList(filter));

    callback?.();
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionUpdateLocationFailed());
  }
}

function* quickpUdateRoomStatus({ payload }) {
  const {
    filter, callback, roomInfo,
  } = payload;

  try {
    yield locationApi.quickpUdateRoomStatus({
      roomInfo,
    });

    yield put(actionQuickUpdateRoomStatusSuccess());

    showSuccess('Cập nhật thông tin phòng thành công');

    yield put(actionGetRoomStatusList(filter));

    callback?.();
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionQuickUpdateRoomStatusFailed());
  }
}

export default function* roomSaga() {
  yield takeLeading(GET_ROOM_STATUS_LIST, getRoomStatusList);
  yield takeLeading(UPDATE_ROOM_STATUS_LIST, updateRoomStatusList);
  yield takeLeading(QUICK_UPDATE_ROOM_STATUS, quickpUdateRoomStatus);
}
